import { render, staticRenderFns } from "./Generic_Measurement.vue?vue&type=template&id=646d1ca5&scoped=true&"
import script from "./Generic_Measurement.vue?vue&type=script&lang=js&"
export * from "./Generic_Measurement.vue?vue&type=script&lang=js&"
import style0 from "./Generic_Measurement.vue?vue&type=style&index=0&id=646d1ca5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d1ca5",
  null
  
)

export default component.exports